import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { PeriodPicker } from '../common/molecules';
import { utilizationApi } from '../../services';
import { handleAppError } from '../handlers';
import { MetricManager } from '../../managers/HRAManager';
import { UtilizationGraphManager, ContractsManager } from '../../managers';
import { HRALocked, HraLow } from '../../assets/images';
import { HRA_LOCK_CONTENT, FILTER } from '../../constants/utilization';
import { UtilizationLockScreen, NoUtilizationCard } from '../common/organisms';
import {HRA} from '../common/templates/Utilization';
let token = '';

class HRAPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      utilizationObj: {},
      loading: true,
      show_no_utilization: false,
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();

    var promise1 = utilizationApi.hraFetchMetrics({ contractId, startDate, endDate, cancelToken: token.token });
    var promise2 = utilizationApi.hraFetchUtilizationGraph({
      contractId,
      startDate,
      endDate,
      filter: 'department',
      cancelToken: token.token,
    });

    Promise.all([promise1, promise2])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = new MetricManager(resp_arr[0]);
        var utilizationObj = new UtilizationGraphManager(resp_arr[1], 'department');
        utilizationObj.xAxesLabel = 'Departments';
        var show_no_utilization = metricObj.hraCompleted === 0;
        this.setState({
          metricObj,
          utilizationObj,
          loading: false,
          show_no_utilization,
        });
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'HRA');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          startDate: contractObj.formattedData[0].start_date,
          endDate: contractObj.formattedData[0].end_date,
          totalCustomers: contractObj.formattedData[0].total_customers,
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  getUtilizationBarData = ({ filter, xAxesLabel }) => {
    let utilizationObj = { barlabels: [], bardata: [], barBgColors: [], xAxesLabel: xAxesLabel };
    utilizationApi.hraFetchUtilizationGraph(
      { contractId: this.state.contractId, startDate: this.state.startDate, endDate: this.state.endDate, filter: filter },
      (resp) => {
        utilizationObj = new UtilizationGraphManager(resp.data, filter);
        utilizationObj.xAxesLabel = xAxesLabel;
        this.setState({ utilizationObj });
      },
      (err) => {
        this.setState({ utilizationObj });
        handleAppError(err);
      }
    );
  };

  toggleHelp = () => this.props.toggleHelp('Health_Risk_Assessment');

  content = (selectedContractObj) => {
    const { show_no_utilization, loading } = this.state;

    if (loading || selectedContractObj.enable_hra) {
      return show_no_utilization ? (
        <NoUtilizationCard
          line='health risk assessment utilization'
          imgsrc={HraLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <HRA {...this.state} sqaureTabHandler={(type) => this.getUtilizationBarData(FILTER[type])} toggleHelp={this.toggleHelp} />
      );
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Health Risk Assessment is not enabled'
            image={HRALocked}
            sectionSubtitle='Benefits to your employees'
            points={HRA_LOCK_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        metricObj: {},
        utilizationObj: {},
        loading: true,
        show_no_utilization: false,
      });
    }
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;

    return (
      <div className='min-w-0'>
        {/* Title block left, period control right, so the filter sits with the page identity rather than
            below it where it read as the first row of content. */}
        <div className='flex flex-wrap items-start justify-between gap-ds-4'>
          <div className='min-w-0'>
            <Breadcrumb
              list={[
                { text: 'Engagement', link: '/stepathon' },
                { text: 'Health Risk Assessment', link: '/health-risk-assessment' },
              ]}
              classes='mb-1'
            />
            {typeof this.state.selectedContractObj !== 'undefined' && (
              <Heading
                mainHeading='Utilization of Health Risk Assessment'
                mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
              />
            )}
          </div>
          <PeriodPicker
            loading={loading}
            list={formattedData}
            classes='shrink-0'
            currentPage={this.state.selectedContractObj?.text}
            setContract={this.changeContractId}
          />
        </div>
        {this.content(this.state.selectedContractObj)}
      </div>
    );
  }
}
export default HRAPage;
